import React, { Component } from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import { getHotelsInfo } from 'httpClient/requests/searchResults';
import { templatesDestinationsOperations } from 'state/templates/destinations';
import getDestinationByDestinationCode from 'state/selectDestinations/operations/getDestinationByDestinationCode';
import updateDestinationAndFetchSearchResults from 'state/searchResults/operations/updateDestinationAndFetchSearchResults';
import DestinationTemplateComponent from './DestinationTemplateComponent';

class DestinationTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      destination: {},
      destinationCode: null,
      hotels: [],
    };

    this.handleOnClickSeeAllHotels = this.handleOnClickSeeAllHotels.bind(this);
  }

  componentDidMount() {
    const { destinations } = this.props;

    if (destinations.length === 0) {
      this.props.fetchDestinations();
    } else {
      this.setTemplateState();
    }
  }

  componentDidUpdate(prevProps) {
    const { destinations } = this.props;

    if (prevProps.destinations.length === 0 && destinations.length > 0) {
      this.setTemplateState();
    }
  }

  setTemplateState() {
    const { content, destinations } = this.props;

    let destinationCode = content.destination_code;
    if (!destinationCode && content.country_code) {
      const destCountry = _find(destinations, (country) => country.code === content.country_code);
      if (destCountry && destCountry.destinations && destCountry.destinations[0]) {
        destinationCode = destCountry.destinations[0].code;
      }
    }

    if (destinationCode) {
      getHotelsInfo({ destinations: [destinationCode] })
        .then((response) => {
          this.setState({
            destinationCode,
            destination: this.props.getDestinationByDestinationCode(destinationCode),
            hotels: response.data,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  handleOnClickSeeAllHotels() {
    const { destination } = this.state;

    if (destination && !_isEmpty(destination)) {
      const { updateDestinationAndFetchSearchResults } = this.props;
      updateDestinationAndFetchSearchResults(destination);
    }
  }

  render() {
    const { content } = this.props;
    const { destination, hotels, destinationCode } = this.state;

    let destinationMap = null;
    if (content.destination_code !== undefined || destinationCode !== null) {
      destinationMap = [
        {
          code: content.destination_code !== undefined ? content.destination_code : destinationCode,
          name: content.title,
        },
      ];
    }

    const showSpinner = hotels.length === 0;

    return (
      <DestinationTemplateComponent
        content={content}
        countHotels={destination.countHotels}
        hotels={hotels}
        destinationMap={destinationMap}
        recommendedHotelsLabel={content.title}
        showSpinner={showSpinner}
        onClickSeeAllHotels={this.handleOnClickSeeAllHotels}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    destinations: state.templates.destinations.destinations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchDestinations() {
      dispatch(templatesDestinationsOperations.fetchDestinations());
    },
    getDestinationByDestinationCode(destinationCode) {
      return dispatch(getDestinationByDestinationCode(destinationCode));
    },
    updateDestinationAndFetchSearchResults(destination) {
      dispatch(updateDestinationAndFetchSearchResults(destination));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DestinationTemplate);
